/**
 * Social media buttons component for company links
 */

import React from 'react';
import { Linkedin, Facebook, Instagram, Youtube, Twitter } from 'lucide-react';

interface SocialMediaButtonsProps {
  linkedinUrl?: string;
  facebookUrl?: string;
  instagramUrl?: string;
  youtubeUrl?: string;
  tiktokUrl?: string;
  className?: string;
}

export const SocialMediaButtons: React.FC<SocialMediaButtonsProps> = ({
  linkedinUrl,
  facebookUrl,
  instagramUrl,
  youtubeUrl,
  tiktokUrl,
  className = '',
}) => {
  const socialLinks = [
    { url: linkedinUrl, icon: Linkedin, label: 'LinkedIn', color: 'text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300' },
    { url: facebookUrl, icon: Facebook, label: 'Facebook', color: 'text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300' },
    { url: instagramUrl, icon: Instagram, label: 'Instagram', color: 'text-pink-600 hover:text-pink-700 dark:text-pink-400 dark:hover:text-pink-300' },
    { url: youtubeUrl, icon: Youtube, label: 'YouTube', color: 'text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300' },
    { url: tiktokUrl, icon: Twitter, label: 'TikTok', color: 'text-gray-700 hover:text-gray-800 dark:text-gray-300 dark:hover:text-gray-200' },
  ].filter(link => link.url);

  if (socialLinks.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {socialLinks.map(({ url, icon: Icon, label, color }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center justify-center w-10 h-10 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 ${color} transition-all hover:scale-110 hover:shadow-md`}
          title={label}
          aria-label={`Visit ${label}`}
        >
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
};



